export default "__VITE_ASSET__33bc5173__"